/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { GroupsControllerGetDocumentGroupsQueryResponse, GroupsControllerGetDocumentGroupsPathParams, GroupsControllerGetDocumentGroupsQueryParams, GroupsControllerGetDocumentGroups400, GroupsControllerGetDocumentGroups401, GroupsControllerGetDocumentGroups403, GroupsControllerGetDocumentGroups404 } from "../../models/documentGroupsController/GroupsControllerGetDocumentGroups";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { groupsControllerGetDocumentGroups } from "../../clients/document-groupsService/groupsControllerGetDocumentGroups";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const groupsControllerGetDocumentGroupsQueryKey = (documentId: GroupsControllerGetDocumentGroupsPathParams["documentId"], params: GroupsControllerGetDocumentGroupsQueryParams) => [{
  url: '/api/v1/documents/groups/documents/:documentId',
  params: {
    documentId: documentId
  }
}, ...(params ? [params] : [])] as const;
export type GroupsControllerGetDocumentGroupsQueryKey = ReturnType<typeof groupsControllerGetDocumentGroupsQueryKey>;
export function groupsControllerGetDocumentGroupsQueryOptions(documentId: GroupsControllerGetDocumentGroupsPathParams["documentId"], params: GroupsControllerGetDocumentGroupsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = groupsControllerGetDocumentGroupsQueryKey(documentId, params);
  return queryOptions<GroupsControllerGetDocumentGroupsQueryResponse, ResponseErrorConfig<GroupsControllerGetDocumentGroups400 | GroupsControllerGetDocumentGroups401 | GroupsControllerGetDocumentGroups403 | GroupsControllerGetDocumentGroups404>, GroupsControllerGetDocumentGroupsQueryResponse, typeof queryKey>({
    enabled: !!(documentId && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return groupsControllerGetDocumentGroups(documentId, params, config);
    }
  });
}

/**
 * @description Returns every group of the requested type(s) the document is a member of, with all of its members. For ORDER_OF_PRECEDENCE this is the precedence chain around the document: members ordered by rank (lower governs; ties share a tier; null = unranked). Members are `document-group-members` resources (rank, role, reason, status, citations with resolved source/target annotations) and sideload via `include=members`; their documents sideload via `include=members.document`. Members of VERSIONED or DELETED documents are omitted. A document in no group of the requested type returns an empty collection; a VERSIONED or DELETED document returns an empty collection even if it is still a member.
 * @summary List the document groups a document belongs to
 * {@link /api/v1/documents/groups/documents/:documentId}
 */
export function useGroupsControllerGetDocumentGroups<TData = GroupsControllerGetDocumentGroupsQueryResponse, TQueryData = GroupsControllerGetDocumentGroupsQueryResponse, TQueryKey extends QueryKey = GroupsControllerGetDocumentGroupsQueryKey>(documentId: GroupsControllerGetDocumentGroupsPathParams["documentId"], params: GroupsControllerGetDocumentGroupsQueryParams, options: {
  query?: Partial<QueryObserverOptions<GroupsControllerGetDocumentGroupsQueryResponse, ResponseErrorConfig<GroupsControllerGetDocumentGroups400 | GroupsControllerGetDocumentGroups401 | GroupsControllerGetDocumentGroups403 | GroupsControllerGetDocumentGroups404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? groupsControllerGetDocumentGroupsQueryKey(documentId, params);
  const query = useQuery({
    ...groupsControllerGetDocumentGroupsQueryOptions(documentId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GroupsControllerGetDocumentGroups400 | GroupsControllerGetDocumentGroups401 | GroupsControllerGetDocumentGroups403 | GroupsControllerGetDocumentGroups404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}